export default theme => ({
    pageWrapper: {
        padding: theme.spacing(3)
    },

    /* Container Grid : aligne en haut pour que sticky fonctionne */
    bodyGrid: {
        alignItems: 'flex-start'
    },

    merchantTypeChip: {
        backgroundColor: '#F0F7FD',
        border: '1px solid #C5DDF0',
        borderRadius: 6,
        padding: '4px 10px',
        color: '#1A6FA3',
        fontSize: 12,
        fontWeight: 500
    },

    /* ── Header ───────────────────────────────────────── */
    header: {
        display: 'flex',
        alignItems: 'center',
        gap: theme.spacing(1.5),
        marginBottom: theme.spacing(3)
    },
    backBtn: {
        width: 36,
        height: 36,
        borderColor: theme.palette.divider,
        boxShadow: '0 0 0 1px rgba(63,63,68,0.05), 0 1px 3px 0 rgba(63,63,68,0.15)',
        backgroundColor: theme.palette.background.paper,
        '&:hover': { backgroundColor: theme.palette.action.hover }
    },
    headerTitle: {
        fontWeight: 500,
        fontSize: '1.15rem',
        color: theme.palette.text.primary,
        lineHeight: 1.3
    },
    headerSub: {
        fontSize: '0.78rem',
        color: theme.palette.text.secondary,
        marginTop: 2
    },

    /* ── Options tiles (left panel) ───────────────────── */
    optionsGrid: {
        display: 'grid',
        gridTemplateColumns: 'repeat(3, 1fr)',
        gap: theme.spacing(1),
        marginTop: theme.spacing(0.5),
        alignItems: 'start'
    },
    optionTile: {
        border: '1px solid',
        borderColor: theme.palette.divider,
        borderRadius: 8,
        padding: theme.spacing(1.25, 1.5),
        display: 'flex',
        flexDirection: 'column',
        gap: theme.spacing(1.25),
        transition: 'all 0.15s',
        backgroundColor: theme.palette.background.paper,
        '&:hover': {
            borderColor: theme.palette.text.disabled
        }
    },
    optionTileActive: {
        borderColor: `${theme.palette.primary.main}40`,
        backgroundColor: `${theme.palette.primary.main}08`,
        '&:hover': {
            borderColor: `${theme.palette.primary.main}60`
        }
    },
    optionTileHeader: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        gap: theme.spacing(1),
        cursor: 'pointer'
    },
    optionTileLeft: {
        display: 'flex',
        alignItems: 'center',
        gap: theme.spacing(1),
        minWidth: 0
    },
    optionTileIcon: {
        width: 28,
        height: 28,
        borderRadius: 6,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: theme.palette.background.default,
        color: theme.palette.text.secondary,
        flexShrink: 0,
        transition: 'all 0.15s'
    },
    optionTileIconActive: {
        backgroundColor: `${theme.palette.primary.main}15`,
        color: theme.palette.primary.main
    },
    optionTileLabel: {
        fontSize: '0.82rem',
        fontWeight: 500,
        color: theme.palette.text.primary
    },
    optionSwitch: {
        marginRight: -8
    },

    /* Price slot inside tile (appears when active) */
    optionPriceSlot: {
        paddingTop: theme.spacing(1),
        borderTop: '1px dashed',
        borderTopColor: theme.palette.divider
    },
    optionPriceLabel: {
        fontSize: '0.68rem',
        color: theme.palette.text.disabled,
        textTransform: 'uppercase',
        letterSpacing: '0.04em',
        marginBottom: 4
    },
    optionPriceInput: {
        '& .MuiOutlinedInput-root': {
            backgroundColor: theme.palette.background.paper,
            fontSize: '0.82rem'
        },
        '& .MuiOutlinedInput-input': {
            padding: '8px 10px'
        }
    },

    /* ── Right panel ──────────────────────────────────── */
    rightPanel: {},

    /* Sticky column - left side scrolls, right is fixed */
    rightStickyCol: {
        position: 'sticky',
        top: theme.spacing(2),
        alignSelf: 'flex-start',
        overflowY: 'auto',
        '&::-webkit-scrollbar': {
            width: 6
        },
        '&::-webkit-scrollbar-thumb': {
            backgroundColor: theme.palette.divider,
            borderRadius: 3
        }
    },

    /* Status banner (TOP – colored, drives the eye) */
    statusBanner: {
        padding: theme.spacing(1.75, 2),
        display: 'flex',
        alignItems: 'center',
        gap: theme.spacing(1.25)
    },
    statusBannerUnpaid: { backgroundColor: '#FAEEDA' },
    statusBannerPaid: { backgroundColor: '#EAF3DE' },
    statusBannerCancelled: { backgroundColor: '#FCEBEB' },

    statusIcon: {
        width: 32,
        height: 32,
        borderRadius: '50%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexShrink: 0
    },
    statusIconUnpaid: { backgroundColor: '#FAC775', color: '#633806' },
    statusIconPaid: { backgroundColor: '#C0DD97', color: '#27500A' },
    statusIconCancelled: { backgroundColor: '#F7C1C1', color: '#791F1F' },

    statusTitle: {
        fontSize: '0.82rem',
        fontWeight: 500,
        lineHeight: 1.2
    },
    statusTitleUnpaid: { color: '#633806' },
    statusTitlePaid: { color: '#27500A' },
    statusTitleCancelled: { color: '#791F1F' },

    statusSub: {
        fontSize: '0.7rem',
        opacity: 0.85,
        marginTop: 2
    },
    statusSubUnpaid: { color: '#854F0B' },
    statusSubPaid: { color: '#3B6D11' },
    statusSubCancelled: { color: '#A32D2D' },

    /* Bill ID header with preview PDF button */
    panelIdHeader: {
        padding: theme.spacing(1.25, 1.5, 1.25, 2),
        borderTop: '1px solid',
        borderTopColor: theme.palette.divider,
        borderBottom: '1px solid',
        borderBottomColor: theme.palette.divider,
        display: 'flex',
        alignItems: 'center',
        gap: theme.spacing(1)
    },
    panelIdLeft: {
        display: 'flex',
        alignItems: 'baseline',
        gap: theme.spacing(1),
        flex: 1,
        minWidth: 0
    },
    panelIdNumber: {
        fontSize: '1rem',
        fontWeight: 500,
        fontFamily: '"SF Mono", "Monaco", "Menlo", monospace',
        letterSpacing: '-0.01em',
        color: theme.palette.text.primary
    },
    panelIdDate: {
        fontSize: '0.70rem',
        color: theme.palette.text.secondary
    },
    previewBtn: {
        textTransform: 'none',
        fontSize: '0.72rem',
        fontWeight: 500,
        height: 28,
        padding: '0 10px',
        minWidth: 0,
        borderRadius: 6,
        color: theme.palette.text.secondary,
        borderColor: theme.palette.divider,
        backgroundColor: theme.palette.background.paper,
        flexShrink: 0,
        '& .MuiButton-startIcon': {
            marginRight: 4,
            '& svg': { fontSize: 14 }
        },
        '&:hover': {
            backgroundColor: `${theme.palette.primary.main}10`,
            color: theme.palette.primary.main,
            borderColor: `${theme.palette.primary.main}40`
        }
    },

    panelInfo: {
        padding: theme.spacing(1.5, 2)
    },
    panelInfoRow: {
        display: 'flex',
        alignItems: 'flex-start',
        gap: theme.spacing(1.25),
        padding: theme.spacing(1, 0),
        borderBottom: '1px solid',
        borderBottomColor: theme.palette.divider,
        '&:last-child': { borderBottom: 'none' }
    },
    panelInfoIcon: {
        fontSize: 18,
        color: theme.palette.text.disabled,
        marginTop: 1,
        flexShrink: 0
    },
    panelInfoContent: {
        flex: 1,
        minWidth: 0
    },
    panelInfoKey: {
        fontSize: '0.68rem',
        color: theme.palette.text.disabled,
        textTransform: 'uppercase',
        letterSpacing: '0.04em',
        marginBottom: 1
    },
    panelInfoValue: {
        fontSize: '0.82rem',
        color: theme.palette.text.primary,
        fontWeight: 500,
        lineHeight: 1.3,
        wordBreak: 'break-word'
    },

    /* ── Options chips in right panel ────────────────── */
    panelOptions: {
        padding: theme.spacing(1.5, 2),
        borderTop: '1px solid',
        borderTopColor: theme.palette.divider
    },
    optionsChips: {
        display: 'flex',
        flexWrap: 'wrap',
        gap: theme.spacing(0.75)
    },
    optionChip: {
        display: 'inline-flex',
        alignItems: 'center',
        gap: 5,
        padding: '4px 8px 4px 6px',
        borderRadius: 6,
        backgroundColor: `${theme.palette.primary.main}12`,
        color: theme.palette.primary.main,
        fontWeight: 500,
        '& svg': { fontSize: 14 }
    },
    optionsEmpty: {
        fontSize: '0.72rem',
        color: theme.palette.text.disabled,
        fontStyle: 'italic'
    },

    recapSection: {
        padding: theme.spacing(1.75, 2),
        borderTop: '1px solid',
        borderTopColor: theme.palette.divider
    },
    recapRow: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'baseline',
        fontSize: '0.82rem',
        padding: theme.spacing(0.5, 0)
    },
    recapKey: {
        color: theme.palette.text.secondary,
        fontSize: '0.82rem'
    },
    recapVal: {
        color: theme.palette.text.primary,
        fontSize: '0.82rem'
    },
    recapTotal: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'baseline',
        marginTop: theme.spacing(1)
    },
    recapTotalKey: {
        fontSize: '0.75rem',
        fontWeight: 500,
        letterSpacing: '0.04em',
        textTransform: 'uppercase',
        color: theme.palette.text.secondary
    },
    recapTotalVal: {
        fontSize: '1.4rem',
        fontWeight: 500
    },

    /* ── Action zone (main button + more menu) ────────── */
    actionZone: {
        padding: theme.spacing(1.5, 2),
        borderTop: '1px solid',
        borderColor: theme.palette.divider,
        display: 'flex',
        gap: theme.spacing(1),
        alignItems: 'stretch',
        backgroundColor: theme.palette.background.default
    },
    btnPrimary: {
        flex: 1,
        textTransform: 'none',
        fontWeight: 500,
        borderRadius: 6,
        fontSize: '0.82rem'
    },
    btnMore: {
        width: 38,
        height: 38,
        border: '1px solid',
        borderColor: theme.palette.divider,
        borderRadius: 6,
        backgroundColor: theme.palette.background.paper,
        flexShrink: 0,
        padding: 0,
        '&:hover': {
            backgroundColor: theme.palette.action.hover
        }
    },
    menuItemWarning: {
        color: theme.palette.warning.dark,
        fontSize: '0.85rem',
        '& .MuiListItemIcon-root': {
            color: theme.palette.warning.dark,
            minWidth: 32
        },
        '&:hover': {
            backgroundColor: `${theme.palette.warning.light}30`
        }
    },
    menuItemDanger: {
        color: theme.palette.error.main,
        fontSize: '0.85rem',
        '& .MuiListItemIcon-root': {
            color: theme.palette.error.main,
            minWidth: 32
        },
        '&:hover': {
            backgroundColor: '#FCEBEB'
        }
    },

    /* ── Form card ──────────────────────────────────────── */
    sectionLabel: {
        fontSize: '0.68rem',
        fontWeight: 600,
        letterSpacing: '0.07em',
        textTransform: 'uppercase',
        color: theme.palette.text.disabled,
        marginBottom: theme.spacing(1.75)
    },

    /* ── Internal notes list ────────────────────────────── */
    notesList: {
        marginTop: 24,
        display: 'flex',
        flexDirection: 'column',
        gap: theme.spacing(1)
    },
    noteBody: {
        padding: theme.spacing(1, 1.25),
        backgroundColor: theme.palette.background.default,
        borderRadius: 8,
        border: '1px solid',
        borderColor: theme.palette.primary.light,
        borderLeft: '9px solid'
    },
    noteContent: {
        fontSize: '0.82rem',
        color: theme.palette.text.primary,
        lineHeight: 1.5,
        wordBreak: 'break-word',
        whiteSpace: 'pre-wrap'
    },
    noteEmpty: {
        fontSize: '0.78rem',
        color: theme.palette.text.disabled,
        fontStyle: 'italic'
    },

    /* ── Comment field ──────────────────────────────────── */
    commentLabelRow: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'baseline',
        marginBottom: 4
    },
    commentCounter: {
        fontSize: '0.7rem',
        color: theme.palette.text.disabled
    },

    /* ── Form footer ─────────────────────────────────────── */
    footer: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        flexWrap: 'wrap',
        gap: theme.spacing(1.5),
        marginTop: theme.spacing(2.5)
    },
    footerHint: {
        fontSize: '0.75rem',
        color: theme.palette.text.disabled,
        display: 'flex',
        alignItems: 'center',
        gap: 4
    },
    footerActions: {
        display: 'flex',
        gap: theme.spacing(1)
    },
    btnSave: {
        textTransform: 'none',
        fontWeight: 500,
        borderRadius: 8,
        fontSize: '0.82rem'
    },
    btnCancel: {
        textTransform: 'none',
        fontWeight: 500,
        borderRadius: 8,
        fontSize: '0.82rem',
        color: theme.palette.text.secondary
    },
    infoBanner: {
        display: 'flex',
        alignItems: 'flex-start',
        gap: theme.spacing(1.5),
        padding: theme.spacing(1.5, 1.75),
        backgroundColor: '#E8F0F9',
        border: '1px solid #B8D4ED',
        borderRadius: 8,
        marginBottom: theme.spacing(2)
    },
    infoBannerIcon: {
        width: 28,
        height: 28,
        borderRadius: '50%',
        backgroundColor: `${theme.palette.primary.main}15`,
        color: theme.palette.primary.main,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexShrink: 0
    },
    infoBannerContent: {
        flex: 1,
        fontSize: '0.82rem',
        lineHeight: 1.5,
        color: '#1A3D5E'
    },
    infoBannerTitle: {
        fontSize: '0.82rem',
        fontWeight: 600,
        marginBottom: 2,
        color: '#0C447C'
    },

    /* ── History card (compact, in right column) ────────── */
    historyCard: {
        marginTop: theme.spacing(2)
    },
    historyHeader: {
        padding: theme.spacing(1.5, 2),
        borderBottom: '1px solid',
        borderBottomColor: theme.palette.divider,
        display: 'flex',
        alignItems: 'center',
        gap: theme.spacing(1)
    },
    historyHeaderIcon: {
        fontSize: 16,
        color: theme.palette.text.secondary
    },
    historyTitle: {
        fontSize: '0.72rem',
        fontWeight: 600,
        textTransform: 'uppercase',
        letterSpacing: '0.04em',
        color: theme.palette.text.primary,
        flex: 1
    },
    historyCount: {
        fontSize: '0.68rem',
        color: theme.palette.text.secondary,
        backgroundColor: theme.palette.background.default,
        padding: '2px 8px',
        borderRadius: 10,
        fontWeight: 500
    },
    historyEntry: {
        padding: theme.spacing(1.5, 2),
        borderBottom: '1px solid',
        borderBottomColor: theme.palette.divider,
        '&:last-child': { borderBottom: 'none' }
    },
    historyEntryHead: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        gap: theme.spacing(1),
        marginBottom: theme.spacing(1)
    },
    historyEntryMeta: {
        display: 'flex',
        flexDirection: 'column',
        gap: 1,
        minWidth: 0
    },
    historyEntryDate: {
        fontSize: '0.75rem',
        fontWeight: 500,
        color: theme.palette.text.primary
    },
    historyEntryAuthor: {
        fontSize: '0.7rem',
        color: theme.palette.text.disabled
    },
    historyEntryLink: {
        flexShrink: 0,
        display: 'inline-flex',
        alignItems: 'center',
        gap: 4,
        padding: '3px 8px',
        border: '1px solid',
        borderColor: theme.palette.divider,
        borderRadius: 6,
        backgroundColor: theme.palette.background.paper,
        fontFamily: '"SF Mono", "Monaco", "Menlo", monospace',
        fontSize: '0.7rem',
        color: theme.palette.text.secondary,
        textDecoration: 'none',
        fontWeight: 500,
        transition: 'all 0.15s',
        '&:hover': {
            backgroundColor: `${theme.palette.primary.main}08`,
            color: theme.palette.primary.main,
            borderColor: `${theme.palette.primary.main}40`
        },
        '& svg': {
            fontSize: 11
        }
    },
    historyChanges: {
        display: 'flex',
        flexDirection: 'column',
        borderRadius: 6,
        overflow: 'hidden',
        border: `1px solid ${theme.palette.divider}`
    },
    changeRow: {
        display: 'flex',
        flexDirection: 'column',
        gap: 2,
        lineHeight: 1.4,
        padding: theme.spacing(0.75, 1.25),
        '&:nth-child(odd)': {
            backgroundColor: theme.palette.background.default
        },
        '&:nth-child(even)': {
            backgroundColor: theme.palette.background.paper
        }
    },
    changeField: {
        color: theme.palette.text.secondary,
        fontSize: '0.65rem',
        textTransform: 'uppercase',
        letterSpacing: '0.04em',
        fontWeight: 500
    },
    changeValues: {
        display: 'flex',
        alignItems: 'baseline',
        gap: 5,
        flexWrap: 'wrap'
    },
    changeOld: {
        color: theme.palette.text.disabled,
        textDecoration: 'line-through',
        fontSize: '0.72rem'
    },
    changeArrow: {
        color: theme.palette.text.disabled,
        fontSize: '0.65rem'
    },
    changeNew: {
        color: theme.palette.primary.main,
        fontWeight: 500,
        fontSize: '0.72rem'
    },
    historyEmpty: {
        padding: theme.spacing(2.5, 2),
        textAlign: 'center',
        fontSize: '0.78rem',
        color: theme.palette.text.disabled,
        fontStyle: 'italic'
    },

    /* "See all" button row */
    seeAllRow: {
        padding: theme.spacing(1, 2),
        borderTop: '1px solid',
        borderTopColor: theme.palette.divider,
        backgroundColor: theme.palette.background.default
    },
    seeAllBtn: {
        width: '100%',
        textTransform: 'none',
        fontSize: '0.75rem',
        fontWeight: 500,
        color: theme.palette.primary.main,
        '&:hover': {
            backgroundColor: `${theme.palette.primary.main}08`
        },
        '& .MuiButton-startIcon svg': {
            fontSize: 16
        }
    },

    /* ── Drawer (full history) ────────────────────────── */
    drawerPaper: {
        width: 480,
        maxWidth: '100vw',
        display: 'flex',
        flexDirection: 'column'
    },
    drawerHeader: {
        padding: theme.spacing(2, 2.5),
        borderBottom: '1px solid',
        borderBottomColor: theme.palette.divider,
        display: 'flex',
        alignItems: 'center',
        gap: theme.spacing(1.25)
    },
    drawerHeaderIcon: {
        fontSize: 20,
        color: theme.palette.text.secondary,
        flexShrink: 0
    },
    drawerTitleBlock: {
        flex: 1,
        minWidth: 0
    },
    drawerTitle: {
        fontSize: '0.92rem',
        fontWeight: 600,
        color: theme.palette.text.primary
    },
    drawerSub: {
        fontSize: '0.75rem',
        color: theme.palette.text.secondary,
        marginTop: 2
    },
    drawerSearchRow: {
        padding: theme.spacing(1.5, 2.5),
        borderBottom: '1px solid',
        borderBottomColor: theme.palette.divider,
        backgroundColor: theme.palette.background.default
    },
    drawerBody: {
        flex: 1,
        overflowY: 'auto'
    },
    drawerEntry: {
        padding: theme.spacing(1.75, 2.5),
        borderBottom: '1px solid',
        borderBottomColor: theme.palette.divider,
        '&:last-child': { borderBottom: 'none' }
    },
    drawerEmpty: {
        padding: theme.spacing(4),
        textAlign: 'center',
        fontSize: '0.82rem',
        color: theme.palette.text.disabled,
        fontStyle: 'italic'
    }
});

const skeleton = theme => ({
    /* ── Skeleton loading ─────────────────────────────── */
    '@keyframes shimmer': {
        '0%': { backgroundPosition: '-200% 0' },
        '100%': { backgroundPosition: '200% 0' }
    },
    skel: {
        background: `linear-gradient(90deg, ${theme.palette.action.hover} 0%, ${theme.palette.action.selected} 50%, ${theme.palette.action.hover} 100%)`,
        backgroundSize: '200% 100%',
        animation: '$shimmer 1.5s ease-in-out infinite',
        borderRadius: 4
    },
    skelInfoBanner: { height: 64, borderRadius: 8, marginBottom: theme.spacing(2) },
    skelLabel: { width: 100, height: 10, marginBottom: theme.spacing(1.75) },
    skelSection: { marginBottom: theme.spacing(3.5) },
    skelFieldsRow: { display: 'flex', gap: theme.spacing(2) },
    skelField: { flex: 1, height: 42, borderRadius: 4 },
    skelTilesGrid: {
        display: 'grid',
        gridTemplateColumns: 'repeat(3, 1fr)',
        gap: theme.spacing(1)
    },
    skelTile: { height: 56, borderRadius: 8 },
    skelTextarea: { height: 110, borderRadius: 4 },

    skelStatusBanner: { height: 58 },
    skelIdRow: {
        padding: theme.spacing(1.5, 2),
        borderTop: '1px solid',
        borderTopColor: theme.palette.divider,
        borderBottom: '1px solid',
        borderBottomColor: theme.palette.divider,
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center'
    },
    skelId: { width: 90, height: 14 },
    skelPdfBtn: { width: 80, height: 28, borderRadius: 6 },
    skelInfoRows: { padding: theme.spacing(2) },
    skelInfoRow: { display: 'flex', gap: theme.spacing(1.5), padding: theme.spacing(1, 0) },
    skelInfoIcon: { width: 18, height: 18, borderRadius: 4, flexShrink: 0, marginTop: 2 },
    skelInfoContent: { flex: 1, display: 'flex', flexDirection: 'column', gap: 6 },
    skelInfoKey: { width: 60, height: 8 },
    skelInfoValue: { width: '80%', height: 12 },
    skelDividerSection: {
        padding: theme.spacing(1.75, 2),
        borderTop: '1px solid',
        borderTopColor: theme.palette.divider,
        display: 'flex',
        flexDirection: 'column',
        gap: theme.spacing(1.25)
    },
    skelRecapRow: { display: 'flex', justifyContent: 'space-between' },
    skelRecapKey: { width: 80, height: 10 },
    skelRecapVal: { width: 50, height: 10 },
    skelTotalVal: { width: 80, height: 22 },
    skelActions: {
        padding: theme.spacing(1.5, 2),
        borderTop: '1px solid',
        borderTopColor: theme.palette.divider,
        backgroundColor: theme.palette.background.default,
        display: 'flex',
        gap: theme.spacing(1)
    },
    skelBtnMain: { flex: 1, height: 38, borderRadius: 6 },
    skelBtnIcon: { width: 38, height: 38, borderRadius: 6 },

    skelHistoryHeader: {
        padding: theme.spacing(1.5, 2),
        borderBottom: '1px solid',
        borderBottomColor: theme.palette.divider,
        display: 'flex',
        alignItems: 'center',
        gap: theme.spacing(1)
    },
    skelHistoryIcon: { width: 16, height: 16, borderRadius: '50%' },
    skelHistoryTitle: { width: 90, height: 12 },
    skelHistoryCount: { width: 24, height: 18, borderRadius: 10, marginLeft: 'auto' },
    skelHistoryEntry: {
        padding: theme.spacing(1.5, 2),
        borderBottom: '1px solid',
        borderBottomColor: theme.palette.divider,
        '&:last-child': { borderBottom: 'none' }
    },
    skelEntryHead: {
        display: 'flex',
        justifyContent: 'space-between',
        marginBottom: theme.spacing(1.25)
    },
    skelEntryMeta: { display: 'flex', flexDirection: 'column', gap: 4 },
    skelEntryDate: { width: 100, height: 11 },
    skelEntryAuthor: { width: 70, height: 9 },
    skelEntryLink: { width: 58, height: 22, borderRadius: 6 },
    skelChangesBlock: {
        padding: theme.spacing(1, 1.25),
        backgroundColor: theme.palette.background.default,
        borderRadius: 6,
        display: 'flex',
        flexDirection: 'column',
        gap: theme.spacing(0.75)
    },
    skelChangeRow: { display: 'flex', flexDirection: 'column', gap: 3 },
    skelChangeField: { width: 80, height: 8 },
    skelChangeVal: { width: '60%', height: 10 }
});

export { skeleton };
